import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import type { ExperimentalMigratePages } from '../__types__/ExperimentalSchema';

export const experimentalMigratePages: ExperimentalMutations['experimentalMigratePages'] = (
	_,
	{ contentId, contentHash },
	{ network: { BadStatusError, cfetch } },
) =>
	cfetch(`/wiki/rest/api/content/${contentId}/convert?hash=${contentHash}`, {
		method: 'PUT',
		headers: {
			'Content-Type': MediaType.JSON,
			'X-Requested-With': 'XMLHttpRequest',
		},
	})
		.catch((reason) => {
			if (BadStatusError.isBadStatusError(reason)) {
				return reason.response;
			}
			throw reason;
		})
		.then<ExperimentalMigratePages>((response) => ({
			status: String(response.status),
		}));
